import { useLingui } from '@lingui/react/macro';
import { Label } from '@utima/ui';
import { useFieldState } from 'informed';
import { memo } from 'react';

import { Card } from '@/components/card/Card';

import {
  MIN_LENGTH,
  SPECIAL_CHARS,
  passwordValidate,
  PasswordValidationError,
} from './passwordValidate';
import { ValidationIcon } from './ValidationIcon';

type PasswordHintProps = {
  className?: string;
};

export const PasswordHint = memo(function ({ className }: PasswordHintProps) {
  const { t } = useLingui();
  const { value: password } = useFieldState('password');
  const { value: confirmPassword } = useFieldState('confirmPassword');

  const validationErrors = passwordValidate(
    password as string,
    confirmPassword as string,
  );

  return (
    <Card className={className} title={t`Password must contain:`}>
      <Label className='inline-flex items-center gap-1.5'>
        <ValidationIcon
          validationErrors={validationErrors}
          targetValidationError={PasswordValidationError.LENGTH}
        />
        {t`Password must be at least ${MIN_LENGTH} characters long`}
      </Label>
      <Label className='inline-flex items-center gap-1.5'>
        <ValidationIcon
          validationErrors={validationErrors}
          targetValidationError={PasswordValidationError.UPPERCASE}
        />
        {t`Password must contain at least one uppercase letter`}
      </Label>
      <Label className='inline-flex items-center gap-1.5'>
        <ValidationIcon
          validationErrors={validationErrors}
          targetValidationError={PasswordValidationError.NUMBER}
        />
        {t`Password must contain at least one number`}
      </Label>
      <Label className='inline-flex items-center gap-1.5'>
        <ValidationIcon
          validationErrors={validationErrors}
          targetValidationError={PasswordValidationError.SPECIAL}
        />
        {t`Password must contain at least one special character (${SPECIAL_CHARS.split('').slice(0, 4).join(',')})`}
      </Label>
    </Card>
  );
});
